module.exports = __webpack_public_path__ + "img/Mellangatan_collage.c4cd13ab.jpg";